/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import { DataTable } from '@scuf/datatable';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { Button, Input, Select } from '@scuf/common';
// import './ManageTariffTheme.scss';
// import MangeTariffTOU from './MangeTariffTOU';

const ManageTariffParent = (props: IAny) => {
  const [atleastOneChecked, setAtleastOneChecked] = useState<boolean>(false);

  useEffect(() => {
    if (props.startTime && props.endTime && props.startUnit && props.endUnit) {
      setAtleastOneChecked(true);
    } else {
      setAtleastOneChecked(false);
    }
  }, [props.endTime, props.startTime, props.startUnit, props.endUnit]);

  return (
    <div
      style={props.isNewBill ? { top: '477.5px' } : { top: '435.5px' }}
      className="Time-Of-Range"
    >
      <div className="Input">
        <Input
          label="Start Time"
          value={props.startTime}
          onChange={(value) => props.setStartTime(value)}
        />
        <Select
          options={[
            { text: 'AM', value: 'AM' },
            { text: 'PM', value: 'PM' }
          ]}
          onChange={(value) => {
            props.setStartUnit(value);
          }}
        />
      </div>
      <div className="Input">
        <Input
          label="End Time"
          value={props.endTime}
          onChange={(value) => props.setEndTime(value)}
        />
        <Select
          options={[
            { text: 'AM', value: 'AM' },
            { text: 'PM', value: 'PM' }
          ]}
          onChange={(value) => {
            props.setEndUnit(value);
          }}
        />
      </div>
      <div>
        <Button
          disabled={!atleastOneChecked}
          className="Time-Of-Range-Button"
          onClick={() => props.onDoneClick()}
          content="Done"
        />
      </div>
    </div>
  );
};

export default ManageTariffParent;
